import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import { UserConsumer } from './providers/UserProvider';
import React, { Component } from 'react';
import StandardAppBar from './StandardAppBar';
import PropTypes from 'prop-types';

class BasicLayout extends Component {

  render() {

    const { title, displaySubscription, onGoHome, height, includeMargin } = this.props;

    return (
      <UserConsumer>
        {({ user, hideMaintenance, hideRelease }) => {
          if (!user) return null;
          const minHeight = (user.adminWindow && user.adminWindow.startTime && !hideMaintenance) || (!hideRelease) ?
            '166px'
            :
            includeMargin ? '148px' : '128px';
          return (
            <div
              style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0 }}>
              <StandardAppBar onGoHome={onGoHome} title={title} displaySubscription={displaySubscription} />
              <div
                style={{
                  minHeight: `calc(100% - ${minHeight})`,
                  ...(height) && { height },
                  borderBottom: 'solid 1px #9E9E9E',
                  marginTop: (user.adminWindow && user.adminWindow.startTime && !hideMaintenance) || (!hideRelease) ? '38px' : '0px'
                }}>
                <div style={{ marginTop: includeMargin ? '20px' : '0px', height: '100%' }}>
                  {this.props.children}
                </div>
              </div>
              <p data-test="release-no"
                role="contentinfo"
                aria-label="Release number"
                style={{
                  float: 'left',
                  marginLeft: 40,
                  fontSize: 14,
                  height: '40px',
                  marginTop: 18
                }}>
                <span><a style={{ marginRight: 20 }} rel="noreferrer" href="https://graphologi.com/release" target="_blank">Release {process.env.REACT_APP_VERSION}</a></span>
                <span aria-hidden="true" style={{ marginLeft: 20 }}><VideoLibraryIcon style={{ verticalAlign: 'middle', color: '#84BC01' }} /> <a href="https://graphologi.com/learn" rel="noreferrer" target="_blank">Learn how to use Graphologi</a></span>
              </p>
              <p
                role="contentinfo"
                aria-label="Graphologi maker information"
                style={{
                  float: 'right',
                  marginRight: 40,
                  height: '40px',
                  marginTop: 10
                }}
              >
                <span style={{ marginRight: 5, fontSize: 14 }}>Graphologi from</span> <a arial-label="Go to Graphifi site" rel="noreferrer" href="https://graphifi.com" target="_blank"><img style={{ verticalAlign: 'middle', height: 40 }} src="/images/GraphifiLogoRGB.png" alt="Graphifi Logo" /></a></p>
            </div>
          );
        }}
      </UserConsumer>
    );
  }
}

BasicLayout.defaultProps = {
  displaySubscription: true,
  includeMargin: true
};

BasicLayout.propTypes = {
  height: PropTypes.string,
  includeMargin: PropTypes.bool,
  onGoHome: PropTypes.func,
  title: PropTypes.string,
  displaySubscription: PropTypes.bool
};

export default BasicLayout;
